/*dropdown nav on mobile -- start*/
$(document).ready(function () {
    $('.catalog-store__geo_mobile .catalog-store__geoItem.catalog-store__geoItem_main').on('click', function(e) {
        e.preventDefault();
        $(this).find('.catalog-store__geoLink.active span.geoLink__icon_arrow').toggleClass('rotate');
        $(this).next('.catalog-store__geoList').toggleClass('show');
    });
});
/*dropdown nav on mobile -- end*/

/*tabs on mobile -- start*/
$(document).ready(function () {

    $('.catalog-store__tabsWrap .tab__link').on('click', function (e) {
        e.preventDefault();

        var $this = $(this),
            tabItem = $this.closest('.catalog-store__tabsWrap .tab__item'),
            otherTabItems = tabItem.siblings(),
            reqTabIndex = tabItem.index(),
            contentItemsArray = $('.catalog-store__tabsWrap .tab__content-item'),
            contentItem = contentItemsArray.eq(reqTabIndex),
            otherContentItems = contentItem.siblings();

        tabItem.addClass('active');
        contentItem.addClass('active');
        otherTabItems.removeClass('active');
        otherContentItems.removeClass('active');
    });
});
/*tabs on mobile -- end*/

/*search clearing -- start*/
$(document).ready(function () {
    $('.store__search input.searchOnMap__input').on('input', function () {
        $(this).next('.searchOnMap__input-clear').addClass('active');

        if ($(this).val() === '') {
            $(this).next('.searchOnMap__input-clear').removeClass('active');
        }
    });

    $('.store__search .searchOnMap__input-clear').on('click', function () {
        $(this).prev('input.searchOnMap__input').val('');
        $(this).removeClass('active');
    });
});
/*search clearing -- end*/

$(document).ready(function () {
    /*ymaps - add & customize -- start*/

    function init() {
        var myMap = new ymaps.Map('mapStores', {
                center: [55.751574, 37.573856],
                zoom: 9,
                controls: []
            }, {
                searchControlProvider: 'yandex#search'
            }),

            // https://yandex.ru/dev/maps/jsapi/doc/2.1/ref/reference/ClusterPlacemark.html#:~:text=Примеры:-,1.,-// Переменная с описанием
            MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
                '<div class="store-map__cluster">{{ properties.geoObjects.length }}</div>'
            ),

            // https://yandex.ru/dev/maps/jsbox/2.1/clusterer_custom_icon/
            clusterer = new ymaps.Clusterer({
                // Зададим массив, описывающий иконки кластеров разного размера.
                clusterIcons: [
                    {
                        href: 'images/map-group-marker.png',
                        size: [40, 40],
                        offset: [-20, -20]
                    }
                ],
                // Эта опция отвечает за размеры кластеров.
                // В данном случае для кластеров, содержащих до 100 элементов,
                // будет показываться маленькая иконка. Для остальных - большая.
                clusterNumbers: [10],
                clusterIconContentLayout: MyIconContentLayout
            }),

            // Создадим пользовательский макет ползунка масштаба.
            ZoomLayout = ymaps.templateLayoutFactory.createClass("<div class='zoomBtns'>" +
                "<div id='zoom-in' class='zoomBtn zoomBtn_plus'></div>" +
                "<div id='zoom-out' class='zoomBtn zoomBtn_minus'></div>" +
                "</div>", {

                // Переопределяем методы макета, чтобы выполнять дополнительные действия
                // при построении и очистке макета.
                build: function () {
                    // Вызываем родительский метод build.
                    ZoomLayout.superclass.build.call(this);

                    // Привязываем функции-обработчики к контексту и сохраняем ссылки
                    // на них, чтобы потом отписаться от событий.
                    this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                    this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);

                    // Начинаем слушать клики на кнопках макета.
                    $('#zoom-in').bind('click', this.zoomInCallback);
                    $('#zoom-out').bind('click', this.zoomOutCallback);
                },

                clear: function () {
                    // Снимаем обработчики кликов.
                    $('#zoom-in').unbind('click', this.zoomInCallback);
                    $('#zoom-out').unbind('click', this.zoomOutCallback);

                    // Вызываем родительский метод clear.
                    ZoomLayout.superclass.clear.call(this);
                },

                zoomIn: function () {
                    var map = this.getData().control.getMap();
                    map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                },

                zoomOut: function () {
                    var map = this.getData().control.getMap();
                    map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                }
            }),
            zoomControl = new ymaps.control.ZoomControl({options: {layout: ZoomLayout}});

        myPlacemark = new ymaps.Placemark([55.684758, 37.738521], {
            hintContent: 'Название ТЦ',
            balloonContent: '<div class="mapBalloonContent">\n' +
                '    <div class="mapBalloonContent__title">ТЦ Гагагринский</div>\n' +
                '    <div class="mapBalloonContent__info">\n' +
                '        <div class="mapBalloonContent__info_p shop__adress">г. Нижний Новгород, пр. Гагарина,  д. 105 А, 1 этаж</div>\n' +
                '        <div class="mapBalloonContent__info_p shop__phone">8 (831) 2-808-202, доб. 206</div>\n' +
                '        <div class="mapBalloonContent__info_p shop__timetable">Режим работы: 10:00-22:00</div>\n' +
                '    </div>\n' +
                '    <a href="https://senatnn.ru/" class="mapBalloonContent__btn">Посмотреть магазин</a>\n' +
                '</div>'
        }, {
            // Опции.
            // Необходимо указать данный тип макета.
            iconLayout: 'default#image',
            // Своё изображение иконки метки.
            iconImageHref: 'images/map-marker.svg',
            // Размеры метки.
            iconImageSize: [36, 50]
        });

        myPlacemark2 = new ymaps.Placemark([55.733436, 37.735175], {
            hintContent: '2 Название ТЦ',
            balloonContent: '<div class="mapBalloonContent">\n' +
                '    <div class="mapBalloonContent__title">2 ТЦ Гагагринский</div>\n' +
                '    <div class="mapBalloonContent__info">\n' +
                '        <div class="mapBalloonContent__info_p shop__adress">г. Нижний Новгород, пр. Гагарина,  д. 105 А, 1 этаж</div>\n' +
                '        <div class="mapBalloonContent__info_p shop__phone">8 (831) 2-808-202, доб. 206</div>\n' +
                '        <div class="mapBalloonContent__info_p shop__timetable">Режим работы: 10:00-22:00</div>\n' +
                '    </div>\n' +
                '    <a href="https://senatnn.ru/" class="mapBalloonContent__btn">Посмотреть магазин</a>\n' +
                '</div>'
        }, {
            // Опции.
            // Необходимо указать данный тип макета.
            iconLayout: 'default#image',
            // Своё изображение иконки метки.
            iconImageHref: 'images/map-marker.svg',
            // Размеры метки.
            iconImageSize: [36, 50]
        });

        clusterer.add([
            myPlacemark,
            myPlacemark2
        ]);
        myMap.geoObjects.add(clusterer);
        myMap.controls.add(zoomControl, {
            position: {
                right: 24,
                top: 32
            }
        });

    }

    if ($('#mapStores').length) {
        ymaps.ready(init);
    }

    /*ymaps - add & customize -- end*/
});
